import EmptyRouterView from './../views/administrative/EmptyRouterView.vue'
import Administrative from './../views/administrative/Home.vue'
import Stablishment from './../views/administrative/manteiners/stablishment/Stablishment.vue'
import Stament from './../views/administrative/manteiners/stament/Stament.vue'
import Usertype from './../views/administrative/manteiners/userType/UserType.vue'

import Users from './../views/administrative/manteiners/users/Users.vue'
import Locations from './../views/administrative/manteiners/location/Location.vue'
import Terms from './../views/administrative/manteiners/term/Term.vue'
import TypeSelections from './../views/administrative/manteiners/type_selection/Type_Selection.vue'
import Questionnare from './../views/administrative/questionnarie/Home.vue'
import Charts from './../views/administrative/charts/Home.vue'

export const routes = [
  { path: '/administrativo', 
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: 'administrativeHome', 
        component: Administrative,
      },
      {
        path:'establecimientos',
        name:'stablishments',
        component:Stablishment
      },  
      {
        path:'locaciones',
        name:'locations',
        component:Locations
      },  
      {
        path:'terms',
        name:'terminoCondiciones',
        component:Terms
      },  
      {
        path:'tipoPreguntas',
        name:'typeselections',
        component:TypeSelections
      },  
      {
        path:'usuarios',
        name:'users',
        component:Users
      },  
      {
        path:'encuesta',
        name:'questionaries',
        component:Questionnare
      },  
      {
        path:'resultados',
        name:'charts',
        component:Charts
      },
      {
        path:"estamentos",
        name:"stament",
        component:Stament
      },
      {
        path:"contractual",
        name:"userType",
        component:Usertype
      }    

    ]
  },
]